import { VersionedTransaction, Connection, Keypair } from '@solana/web3.js';
import bs58 from "bs58";


const RPC_ENDPOINT = process.env.REACT_APP_QUICKNODE_RPC_ENDPOINT
const HELIUS_RPC = process.env.REACT_APP_HELIUS_RPC_ENDPOINT
const NODE = "https://solana-mainnet.core.chainstack.com/d5a9908d05d47de6ed40506b8d796a3c"

const web3Connection = new Connection(
    HELIUS_RPC,
    'confirmed',
);
// const connection = new Connection(
//     "https://api.mainnet-beta.solana.com", // or your custom RPC endpoint
//     { commitment: "confirmed" }
// );



const ConfirmTransaction = async (signature) => {
    let finalized = false;
    let status = null;
    let confirmed = false
    let error = false
    // Polling for the status of the transaction
    while (!finalized || !error) {
        // Get the transaction status
        status = await web3Connection.getSignatureStatus(signature);
        if (status && status.value) {
            if (!confirmed && status.value.confirmationStatus === 'confirmed') {
                confirmed = true

            }
            // If the transaction is finalized
            if (status.value.confirmationStatus === 'finalized') {
                finalized = true;
                return { finalized, confirmed, error }; // Transaction finalized successfully
            }
            // If the transaction was reverted (failed or encountered an error)
            if (status.value.err) {
                console.error("Transaction failed or reverted:", status.value.err);
                error = true;
                return { finalized, confirmed, error }; // Transaction failed or reverted
            }
        }
        // Sleep for a short duration before polling again
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    return false; // In case of unexpec
};

export async function buyPumpToken(userData, mint) {


    const response = await fetch(`https://pumpportal.fun/api/trade-local`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "publicKey": userData?.address,  // Your wallet public key
            "action": "buy",                 // "buy" or "sell"
            "mint": mint,         // contract address of the token you want to trade
            "denominatedInSol": "true",     // "true" if amount is amount of SOL, "false" if amount is number of tokens
            "amount": userData.amount,                  // amount of SOL or tokens
            "slippage": 7,                  // percent slippage allowed
            "priorityFee": 0.00005,          // priority fee
            "pool": "pump"                   // exchange to trade on. "pump" or "raydium"
        })
    });



    if (response.status === 200) {

        try {

            const data = await response.arrayBuffer();
            const tx = VersionedTransaction.deserialize(new Uint8Array(data));
            const signerKeyPair = Keypair.fromSecretKey(bs58.decode(userData.secret));
            tx.sign([signerKeyPair]);
            const signature = await web3Connection.sendTransaction(tx)
            const confirmed = "https://solscan.io/tx/" + signature
            return confirmed
        } catch (err) {
            let status = {
                finalized: false,
                error: true,
                message: response.statusText
            }

            console.log(status)
            return status

        }
        // successfully generated transaction
    }
}


export async function SellPumpToken(userData, mint) {


    const response = await fetch(`https://pumpportal.fun/api/trade-local`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "publicKey": userData?.address.trim(),  // Your wallet public key
            "action": "sell",                 // "buy" or "sell"
            "mint": mint,         // contract address of the token you want to trade
            "denominatedInSol": "false",     // "true" if amount is amount of SOL, "false" if amount is number of tokens
            "amount": '100%',                  // amount of SOL or tokens
            "slippage": 5,                    // percent slippage allowed
            "priorityFee": 0.00005,          // priority fee
            "pool": "pump"                   // exchange to trade on. "pump" or "raydium"
        })
    });




    if (response.status === 200) {

        try {
            const data = await response.arrayBuffer();
            const tx = VersionedTransaction.deserialize(new Uint8Array(data));
            const signerKeyPair = Keypair.fromSecretKey(bs58.decode(userData?.secret.trim()));
            tx.sign([signerKeyPair]);
            const signature = await web3Connection.sendTransaction(tx)
            console.log("Transaction: https://solscan.io/tx/" + signature);
            
            return true

        } catch (err) {



            let status = {
                finalized: false,
                error: true,
                message: response.statusText
            }


            console.log(status)
            return status
        }
    }

}
